import React from "react";
import img1 from "../../assets/ingridients-images/diacare/aswangadha.webp";
import img2 from "../../assets/ingridients-images/diacare/base-satav.webp";
import img3 from "../../assets/ingridients-images/diacare/chopchini.webp";
import img4 from "../../assets/ingridients-images/diacare/jamunbeej.webp";
import img5 from "../../assets/ingridients-images/diacare/mehti.webp";
import img6 from "../../assets/ingridients-images/diacare/painirfull.webp";

const data = [
  {
    title: "Ashwagandha",
    img: img1,
    text: "Promotes cartilage health and flexibility",
  },
  {
    title: "Base Satav",
    img: img2,
    text: "Soothes discomfort & aids recovery",
  },
  {
    title: "Chopchini",
    img: img3,
    text: "Supports joint comfort and inflammation balance",
  },
   {
    title: "Jamun Beej",
    img: img4,
    text: "Imporves flexibility & joint health",
  },
   {
    title: "mehti",
    img: img5,
    text: "Enhances nutrient absorption",
  },
   {
    title: "Painirfull",
    img: img6,
    text: "Promotes comfort",
  },

];

const DiacarePowderIngredients = () => {
  return (
    <section className="ingredients">
      <h2 className="ingredients-title">
        Key Ingredients for Joint Support
      </h2>

      <div className="ingredients-grid">
        {data.map((item, index) => (
          <div className="ingredient-card" key={index}>
            <div className="pill">{item.title}</div>

            <div className="image-circle">
              <img src={item.img} alt={item.title} />
            </div>

            <p>{item.text}</p>
            <div className="card-shadow"></div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default DiacarePowderIngredients;
